import { supabase } from '../lib/supabase';

class DashboardService {
  // Buscar estatísticas gerais do sistema
  async getEstatisticasGerais() {
    try {
      console.log('🔍 Iniciando busca de estatísticas gerais...');
      
      // Buscar contagens individualmente para melhor debug
      let escolas = 0, alunos = 0, testes = 0, conversas = 0;

      // Tentar buscar escolas
      try {
        const { count, error } = await supabase
          .from('escolas')
          .select('*', { count: 'exact', head: true })
          .eq('status', 'ativo');
        
        if (error) {
          console.warn('⚠️ Tabela escolas não encontrada ou erro:', error.message);
        } else {
          escolas = count || 0;
          console.log('✅ Escolas encontradas:', escolas);
        }
      } catch (err) {
        console.warn('⚠️ Erro ao buscar escolas:', err.message);
      }

      // Tentar buscar alunos
      try {
        const { count, error } = await supabase
          .from('alunos')
          .select('*', { count: 'exact', head: true })
          .eq('ativo', true);
        
        if (error) {
          console.warn('⚠️ Tabela alunos não encontrada ou erro:', error.message);
        } else {
          alunos = count || 0;
          console.log('✅ Alunos encontrados:', alunos);
        }
      } catch (err) {
        console.warn('⚠️ Erro ao buscar alunos:', err.message);
      }

      // Tentar buscar testes
      try {
        const { count, error } = await supabase
          .from('testes')
          .select('*', { count: 'exact', head: true });
        
        if (error) {
          console.warn('⚠️ Tabela testes não encontrada ou erro:', error.message);
        } else {
          testes = count || 0;
          console.log('✅ Testes encontrados:', testes);
        }
      } catch (err) {
        console.warn('⚠️ Erro ao buscar testes:', err.message);
      }

      // Tentar buscar conversas
      try {
        const { count, error } = await supabase
          .from('chats')
          .select('*', { count: 'exact', head: true })
          .eq('status', 'ativo');
        
        if (error) {
          console.warn('⚠️ Tabela chats não encontrada ou erro:', error.message);
        } else {
          conversas = count || 0;
          console.log('✅ Conversas encontradas:', conversas);
        }
      } catch (err) {
        console.warn('⚠️ Erro ao buscar conversas:', err.message);
      }

      const resultado = {
        escolas,
        alunos,
        testes,
        conversas
      };

      console.log('📊 Estatísticas finais:', resultado);
      return resultado;
    } catch (error) {
      console.error('❌ Erro geral ao buscar estatísticas:', error);
      // Retornar dados padrão em caso de erro
      return {
        escolas: 0,
        alunos: 0,
        testes: 0,
        conversas: 0
      };
    }
  }

  // Buscar crescimento mensal de alunos
  async getCrescimentoMensalAlunos() {
    try {
      const dataAtual = new Date();
      const inicioMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
      
      const { count, error } = await supabase
        .from('alunos')
        .select('*', { count: 'exact', head: true })
        .gte('created_at', inicioMes.toISOString())
        .eq('ativo', true);

      if (error) {
        console.warn('⚠️ Erro ao buscar crescimento de alunos:', error.message);
        return 0;
      }
      return count || 0;
    } catch (error) {
      console.warn('⚠️ Erro ao buscar crescimento mensal de alunos:', error.message);
      return 0;
    }
  }

  // Buscar crescimento semanal de testes
  async getCrescimentoSemanalTestes() {
    try {
      const dataAtual = new Date();
      const inicioSemana = new Date(dataAtual);
      inicioSemana.setDate(dataAtual.getDate() - dataAtual.getDay());
      inicioSemana.setHours(0, 0, 0, 0);
      
      const { count, error } = await supabase
        .from('testes')
        .select('*', { count: 'exact', head: true })
        .gte('created_at', inicioSemana.toISOString());

      if (error) {
        console.warn('⚠️ Erro ao buscar crescimento de testes:', error.message);
        return 0;
      }
      return count || 0;
    } catch (error) {
      console.warn('⚠️ Erro ao buscar crescimento semanal de testes:', error.message);
      return 0;
    }
  }

  // Buscar crescimento mensal de escolas
  async getCrescimentoMensalEscolas() {
    try {
      const dataAtual = new Date();
      const inicioMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
      
      const { count, error } = await supabase
        .from('escolas')
        .select('*', { count: 'exact', head: true })
        .gte('created_at', inicioMes.toISOString())
        .eq('ativo', true);

      if (error) {
        console.warn('⚠️ Erro ao buscar crescimento de escolas:', error.message);
        return 0;
      }
      return count || 0;
    } catch (error) {
      console.warn('⚠️ Erro ao buscar crescimento mensal de escolas:', error.message);
      return 0;
    }
  }

  // Buscar estatísticas de users/admin (usuários com role admin menos alunos)
  async getEstatisticasUsersAdmin() {
    try {
      console.log('🔍 Buscando estatísticas de users/admin...');
      
      // Buscar total de profiles com role admin
      let totalAdmins = 0;
      try {
        const { count, error } = await supabase
          .from('profiles')
          .select('*', { count: 'exact', head: true })
          .eq('role', 'admin');

        if (error) {
          console.warn('⚠️ Erro ao buscar profiles admin:', error.message);
          // Fallback: buscar todos os profiles
          const { count: totalCount, error: totalError } = await supabase
            .from('profiles')
            .select('*', { count: 'exact', head: true });
          
          if (totalError) {
            console.warn('⚠️ Erro ao buscar total de profiles:', totalError.message);
            return 0;
          }
          totalAdmins = totalCount || 0;
          console.log('📊 Total de profiles (fallback):', totalAdmins);
        } else {
          totalAdmins = count || 0;
          console.log('✅ Profiles com role admin:', totalAdmins);
        }
      } catch (err) {
        console.warn('⚠️ Erro ao buscar profiles:', err.message);
        return 0;
      }

      // Buscar quantidade de alunos para subtrair
      let totalAlunos = 0;
      try {
        const { count, error } = await supabase
          .from('alunos')
          .select('*', { count: 'exact', head: true })
          .eq('ativo', true);

        if (error) {
          console.warn('⚠️ Erro ao buscar alunos para subtração:', error.message);
        } else {
          totalAlunos = count || 0;
          console.log('📊 Total de alunos para subtrair:', totalAlunos);
        }
      } catch (err) {
        console.warn('⚠️ Erro ao buscar alunos:', err.message);
      }

      // Calcular users/admin = total admins - alunos
      const usersAdmin = Math.max(0, totalAdmins - totalAlunos);
      console.log('✅ Users/Admin calculado:', usersAdmin, '(', totalAdmins, '-', totalAlunos, ')');
      
      return usersAdmin;
    } catch (error) {
      console.warn('⚠️ Erro geral ao buscar users/admin:', error.message);
      return 0;
    }
  }

  // Buscar dados completos do dashboard
  async getDadosCompletos() {
    try {
      const [
        estatisticasGerais,
        crescimentoAlunos,
        crescimentoTestes,
        crescimentoEscolas,
        totalUsersAdmin
      ] = await Promise.all([
        this.getEstatisticasGerais(),
        this.getCrescimentoMensalAlunos(),
        this.getCrescimentoSemanalTestes(),
        this.getCrescimentoMensalEscolas(),
        this.getEstatisticasUsersAdmin()
      ]);

      return {
        escolas: {
          total: estatisticasGerais.escolas,
          crescimento: crescimentoEscolas
        },
        alunos: {
          total: estatisticasGerais.alunos,
          crescimento: crescimentoAlunos
        },
        usersAdmin: {
          total: totalUsersAdmin,
          crescimento: 0 // Placeholder para crescimento de users/admin
        },
        testes: {
          total: estatisticasGerais.testes,
          crescimento: crescimentoTestes
        },
        conversas: estatisticasGerais.conversas
      };
    } catch (error) {
      console.error('Erro ao buscar dados completos do dashboard:', error);
      throw error;
    }
  }

  // Buscar atividade recente
  async getAtividadeRecente() {
    try {
      const { data: chatsRecentes, error } = await supabase
        .from('chats')
        .select(`
          id,
          titulo,
          materia,
          data_ultima_atividade,
          alunos!inner(nome)
        `)
        .order('data_ultima_atividade', { ascending: false })
        .limit(5);

      if (error) {
        console.warn('⚠️ Erro ao buscar atividade recente:', error.message);
        return [];
      }

      return chatsRecentes?.map(chat => ({
        id: chat.id,
        titulo: chat.titulo,
        materia: chat.materia,
        aluno: chat.alunos.nome,
        data: chat.data_ultima_atividade
      })) || [];
    } catch (error) {
      console.warn('⚠️ Erro ao buscar atividade recente:', error.message);
      return [];
    }
  }

  // Formatar números para exibição
  formatarNumero(numero) {
    if (numero >= 1000) {
      return (numero / 1000).toFixed(1).replace('.0', '') + 'k';
    }
    return numero.toString();
  }

  // Calcular percentual de crescimento
  calcularCrescimento(atual, anterior) {
    if (anterior === 0) return atual > 0 ? 100 : 0;
    return Math.round(((atual - anterior) / anterior) * 100);
  }
}

export default new DashboardService();
